<template>
  <div class="min-height-for-section mb_controller w-100 mt-4">
    <div class="container-fluid mb-4" v-if="model">
      <div class="row pb-4">
        <div class="col-12">
          <div class="w-100 d-flex align-items-center justify-content-center">
            <div class="login-wrapper p-md-4">
              <h2 class="modal-text">Manage Profile</h2>
              <div class="w-100 mt-4">
                <!-- form -->
                <vue-form :state="formstate" @submit.prevent="onSubmit">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.name)"
                  >
                    <label class="w-100 text-gray text-left">Name</label>
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      required
                      v-model.lazy="model.name"
                    />

                    <field-messages
                      name="name"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Name is a required field
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.email)"
                  >
                    <label class="w-100 text-gray text-left">Email</label>
                    <input
                      type="email"
                      name="email"
                      class="form-control"
                      disabled
                      v-model.lazy="model.email"
                    />

                    <field-messages
                      name="email"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Email is a required field
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.gender)"
                  >
                    <label class="w-100 text-gray text-left">Gender</label>
                    <select
                      class="form-control"
                      id="genderselection"
                      name="gender"
                      v-model.lazy="model.data.gender.id"
                      required
                    >
                      <option
                        v-for="(genderType, index) in genderArr"
                        :key="index"
                        :value="genderType.id == 848 ? '' : genderType.id"
                        >{{ genderType.value.en_US }}</option
                      >
                    </select>
                    <field-messages
                      name="gender"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Gender is a required field
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.nationality)"
                  >
                    <label class="w-100 text-gray text-left">Nationality</label>
                    <select
                      class="form-control"
                      id="nationalityselection"
                      name="nationality"
                      v-model.lazy="model.data.nationality.id"
                      required
                    >
                      <option
                        v-for="(nationalityType, index) in nationalityArr"
                        :key="index"
                        :value="
                          nationalityType.id == 851 ? '' : nationalityType.id
                        "
                        >{{ nationalityType.value.en_US }}</option
                      >
                    </select>

                    <field-messages
                      name="nationality"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Nationality is a required field
                      </div>
                    </field-messages>
                  </validate>
                  <div class="w-100 my-2 error" v-if="errorMsg">
                    {{ errorMsg }}
                  </div>
                  <div class="w-100 my-2 success" v-if="successMsg">
                    Update successful.
                  </div>
                  <div class="py-2 text-center">
                    <button class="modal-default-button mr-2" type="submit">
                      Save
                    </button>
                    <button class="cancel-default-button" @click="goHome()">
                      Cancel
                    </button>
                  </div>
                </vue-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import { mapGetters } from "vuex";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
export default {
  components: {
    BreadCrumbsHeader,
  },
  data() {
    return {
      formstate: {},
      userId: localStorage.getItem("user_id"),
      model: {
        name: "",
        data: {
          gender: {
            id: "",
          },
          nationality: {
            id: "",
          },
        },
      },
      genderArr: [],
      nationalityArr: [],
      errorMsg: "",
      successMsg: "",
    };
  },
  methods: {
    fieldClassName(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
    goHome() {
      this.$router.replace({
        name: "home_new",
      });
    },
    onSubmit: function(e) {
      e.preventDefault();
    },
    async onSubmit(e) {
      e.preventDefault();

      if (
        this.model.name &&
        this.model.data.nationality.id &&
        this.model.data.gender.id
      ) {
        try {
          let res = await axios.put(
            `https://rtb.glueapi.io/v1/user/${this.userId}`,
            {
              name: this.model.name,
              data: {
                gender: this.model.data.gender.id,
                nationality: this.model.data.nationality.id,
              },
            },
            {
              headers: {
                "X-AUTH-TOKEN": localStorage.getItem("token"),
              },
            }
          );
          this.errorMsg = "";
          let data = res.data;
          this.successMsg =
            "Registration Successful! Please login to access your account!";
          return data;
        } catch (error) {
          console.log(error); // this is the main part. Use the response property from the error object
          this.errorMsg = error.response.data.ResponseStatus.Message;
          this.successMsg = "";
          return error.response;
        }
      }
    },
    async getGender() {
      let response = await axios.get(
        "https://rtb.glueapi.io/v1/content-list/12",
        {
          responseType: "json",
        }
      );

      this.genderArr = response.data.data.entries;
    },
    async getNationality() {
      let response = await axios.get(
        "https://rtb.glueapi.io/v1/content-list/11",
        {
          responseType: "json",
        }
      );

      this.nationalityArr = response.data.data.entries;
    },
  },
  created() {
    // console.log(JSON.stringify(this.genderArr, null, 2));
    // console.log(JSON.stringify(this.nationalityArr, null, 2));
    // this.modelfromauth = Object.assign({}, this.$store.getters["auth/user"]);
    // console.log(JSON.stringify(this.modelfromauth, null, 2));
    // if (!this.modelfromauth.data) {
    //   this.modelfromauth.data = {
    //     gender: {
    //       id: 848,
    //     },
    //     nationality: {
    //       id: 851,
    //     },
    //   };
    // }
  },
  mounted() {},

  computed: {
    ...mapGetters("auth", {
      user: "user",
    }),
  },

  watch: {
    user: {
      handler(user) {
        if (user) {
          this.model = user;

          if (!this.model.data.gender || !this.model.data.nationality) {
            this.model.data = {
              gender: {
                id: 848,
              },
              nationality: {
                id: 851,
              },
            };

            this.getGender();
            this.getNationality();
          } else {
            this.getGender();
            this.getNationality();
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.min-height-for-section {
  font-family: "Poppins", sans-serif !important;
}
.pt-livetv {
  padding: 90px 0 0;
  min-height: 80vh;
}
.breadCrumbsWrapper {
  padding: 30px;
}
.modal-text {
  margin-top: 0;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
.signup-text {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  background: #191919;
  border-radius: 4px;
}
.text-yellow {
  color: #f1c40f;
}
.text-black {
  color: black;
}
.text-gray {
  color: #6c757d;
}
.form-label {
  display: block;
  margin-bottom: 1em;
  font-size: 16px;
  color: black;
  text-align: left;
}
.form-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
.form-control:focus {
  color: #a3aebb;
  background-color: #191919;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}
.form-control:disabled {
  background-color: #191919;
}
.form-label > .form-control {
  margin-top: 0.5em;
}
.form-group label {
  text-align: left;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  color: #efefef;
  border: none;
  border-bottom: 1px solid #707070;
  border-radius: unset;
  background: #191919;
}
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
  padding-top: 4px;
}
.error {
  color: red;
  font-size: 16px;
  margin-top: 4px;
}
.success {
  color: green;
  font-size: 16px;
  margin-top: 4px;
}
.modal-default-button {
  background: #f1c40f;
  color: #000000;
  border-radius: 4px;
  padding: 10px 25px;
  border: none;
  outline: none;
}
.cancel-default-button {
  background: #191919;
  color: #ffffff;
  border-radius: 4px;
  padding: 10px 25px;
  border: none;
  outline: none;
}
@media screen and (max-width: 768px) {
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
</style>
